export const reduxName = 'app';